import React from "react";
import { Box, PressableOpacity } from "app/components/common";
import { useSelector } from "react-redux";
import { getNewMessageNotifications } from "@microdoing/shared/services/notification/selectors";
import { useNavigation } from "@react-navigation/native";
import ResourcesIcon from "../icons/LibraryIcon";
import MessageIconButton from "app/components/common/MessageIconButton";
import theme, { Theme } from "app/Theme/Theme";
import normalize from "app/utils/normalize";
import LogoFullMicrodoing from "app/components/Icons/logo/LogoFullMicrodoing";
import { ResponsiveValue } from "@shopify/restyle";

interface IProps {
  title?: React.ReactElement;
  paddingHorizontal?: ResponsiveValue<keyof Theme["spacing"], Theme>;
}

const HeaderTabBar = ({
  title = <LogoFullMicrodoing />,
  paddingHorizontal = "null",
}: IProps) => {
  const newMessages = useSelector(getNewMessageNotifications);

  const navigation = useNavigation();

  const navigateToConversation = () => {
    navigation.navigate("Message");
  };

  const navigateToLibrary = () => {
    navigation.navigate("Library");
  };

  return (
    <Box
      zIndex={12}
      paddingTop="xs"
      marginBottom="sm"
      flexDirection="row"
      width="100%"
      alignItems="center"
      justifyContent="space-between"
      paddingHorizontal={paddingHorizontal}
    >
      {title}
      <Box flexDirection="row">
        <PressableOpacity
          onPress={navigateToLibrary}
          style={{ marginRight: theme.spacing.sm }}
        >
          <ResourcesIcon
            color={theme.colors["neutral.600"]}
            width={normalize(22)}
            height={normalize(24)}
          />
        </PressableOpacity>
        <MessageIconButton
          onPress={navigateToConversation}
          notificationsNumber={newMessages}
          iconColor={
            newMessages
              ? theme.colors["neutral.900"]
              : theme.colors["neutral.600"]
          }
          iconHeight={normalize(24)}
          iconWidth={normalize(24)}
        />
      </Box>
    </Box>
  );
};

export default HeaderTabBar;
